/* ═══════════════════════════════════════════════════════════════
 * SPX — S&P 500-index data via onze eigen Worker-proxy
 * (/api/market/klines, zie worker/marketData.js), die server-side
 * Yahoo Finance's publieke chart-endpoint bevraagt. Geen API-key
 * nodig, maar ook geen WebSocket zoals bij Binance: Yahoo biedt geen
 * gratis realtime push-feed, dus "live" betekent hier periodiek
 * pollen (SpxPoller hieronder) i.p.v. een streamende verbinding.
 * Zelfde candle-vorm als binance.js ({ time (sec), open, high, low,
 * close, volume }), zodat de rest van de terminal (chart, Volume
 * Profile, VWAP, drawTools, ...) geen onderscheid hoeft te maken.
 * ═══════════════════════════════════════════════════════════════ */

const PARTY_HOST = process.env.REACT_APP_PARTY_HOST || "127.0.0.1:8787";
const API_BASE = `${window.location.protocol === "https:" ? "https" : "http"}://${PARTY_HOST}`;

export const SPX_SYMBOL = "^GSPC";

// Welke tf-codes (zie config.js CFG.intervals) voor SPX beschikbaar zijn —
// moet gelijk lopen met YAHOO_TF in worker/marketData.js. Een smallere set
// dan Binance: Yahoo's gratis intraday-granulariteit is beperkter.
export const SPX_INTERVALS = new Set(["1m", "5m", "15m", "30m", "1h", "1d", "1w", "1M"]);

export async function fetchSpxKlines(interval, limit = 1500) {
  const url = `${API_BASE}/api/market/klines?symbol=${encodeURIComponent(SPX_SYMBOL)}` +
    `&interval=${encodeURIComponent(interval)}&limit=${limit}`;
  const res = await fetch(url);
  const body = await res.json().catch(() => null);
  if (!res.ok) throw new Error((body && body.error) || `SPX-data ophalen mislukt (${res.status})`);
  return Array.isArray(body) ? body : [];
}

// ── "Live" via polling ───────────────────────────────────────────
// Geen WebSocket beschikbaar, dus elke POLL_MS seconden de laatste paar
// candles opnieuw ophalen en de huidige/vorige candle bijwerken — zelfde
// merge-logica als BinanceStream.onKline in CoachTerminal.jsx (laatste
// candle vervangen bij gelijke tijd, anders toevoegen).
const POLL_MS = 15000;

export class SpxPoller {
  constructor() {
    this.timer = null;
    this.stopped = true;
  }

  connect(symbol, interval, handlers) {
    this.close();
    this.stopped = false;
    this.handlers = handlers || {};
    this.interval = interval;

    const tick = async () => {
      if (this.stopped) return;
      try {
        const candles = await fetchSpxKlines(this.interval, 3);
        if (this.stopped) return;
        if (this.handlers.onStatus) this.handlers.onStatus("live");
        for (const c of candles) {
          if (this.handlers.onKline) this.handlers.onKline(c);
        }
      } catch (err) {
        if (!this.stopped && this.handlers.onStatus) this.handlers.onStatus("offline");
        console.error("[spx] poll faalde:", err);
      } finally {
        if (!this.stopped) this.timer = setTimeout(tick, POLL_MS);
      }
    };
    // Eerste tick iets vertraagd — de historische fetchSpxKlines() loopt al
    // parallel vanuit CoachTerminal.jsx, geen reden om die te overlappen.
    this.timer = setTimeout(tick, POLL_MS);
  }

  close() {
    this.stopped = true;
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
  }
}
